import { CSSProperties, FC } from 'react';

export interface SvgLoadingBlueProps {
  size?: string; // size of square container
  style?: CSSProperties; // not for height or width
}

export const SvgLoadingBlue: FC<SvgLoadingBlueProps> = ({
  size = '24px',
  style,
}) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...style,
      height: size,
      width: size,
    }}
  >
    <div
      style={{
        position: 'relative',
        height: 0,
        width: '100%',
        padding: 0,
        paddingBottom: '100%',
      }}
    >
      <svg
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          left: 0,
          top: 0,
        }}
        width="54"
        height="54"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          opacity="0.16"
          cx="27"
          cy="27"
          r="24"
          stroke="#6140FF"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51 27C51 13.7452 40.2548 3 27 3"
          stroke="#6140FF"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  </div>
);
